import { APIResponseCodeInterface } from "./Interfaces.constants";

export const CIPHER_KEY = "AS-One2024m";

export const APIResponseCodes: APIResponseCodeInterface = {
  SUCCESS: "10000",
  FAILURE: "10001",
  RETRY: "10002",
  INVALID_ACCESS_TOKEN: "10003",
  INVALID_ENCRYPTED_INPUT: "10004",
  SERVER_ERROR: "10005",
};
